var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-header",
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "space-between" } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "jzq-logo" }, [
                  _c("img", { attrs: { src: "/images/ptlogo.png" } })
                ])
              ]),
              _c(
                "el-col",
                {
                  staticStyle: { "min-width": "300px", background: "#464c5b" },
                  attrs: { span: 4 }
                },
                [
                  _c("div", { staticClass: "jzq-return" }, [
                    _c("ul", [
                      _c("li", [
                        _c("a", { attrs: { href: _vm.junziqanIndex } }, [
                          _vm._v("进入官网")
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-main", [_c("nuxt")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-176a1cfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-176a1cfc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/auth.vue
// module id = mSb4
// module chunks = 204